import { z } from "zod"

const optionalText = z.string().nullish()
const imageUrl = z.url().refine((value) => new URL(value).protocol === "https:", "HTTPS image required")
const dimensionsSchema = z.object({ width: z.number().positive().optional(), height: z.number().positive().optional(), length: z.number().positive().optional() })
export const catalogImageSchema = z.object({
  url: imageUrl, alt: optionalText, variant_sku: optionalText,
  width: z.number().int().positive().optional(), height: z.number().int().positive().optional(),
})
export const catalogProductSchema = z.object({
  id: z.string(), title: z.string(), handle: z.string(),
  subtitle: optionalText, description: optionalText,
  thumbnail: imageUrl.nullish(), updated_at: z.string(),
  images: z.array(z.object({ id: z.string(), url: imageUrl })).nullish(),
  variants: z.array(z.object({
    id: z.string(), title: z.string(), sku: optionalText, ean: optionalText, reference: optionalText,
    variant_rank: z.number().nullish(),
    measurements: z.object({
      product_dimensions_mm: dimensionsSchema.optional(), packaging_dimensions_mm: dimensionsSchema.optional(),
      extension_length_mm: z.number().positive().optional(), net_weight_g: z.number().nonnegative().optional(),
      pack_quantity: z.number().positive().optional(), packaging_type: z.string().optional(),
    }).optional(),
  })).nullish(),
  options: z.array(z.object({ id: z.string(), title: z.string(), values: z.array(z.object({ value: z.string() })).nullish() })).nullish(),
  categories: z.array(z.object({ id: z.string(), name: z.string(), handle: z.string() })).nullish(),
  details: z.object({
    features: z.array(z.object({ title: z.string(), description: optionalText })),
    specifications: z.array(z.object({
      blockType: z.literal("specificationTable"), title: z.string(),
      rows: z.array(z.object({ label: z.string(), value: z.string() })),
    })),
    manuals: z.array(z.object({ title: z.string(), url: imageUrl, language: optionalText, type: optionalText, variant_sku: optionalText })),
    gallery: z.array(catalogImageSchema).optional(),
  }).nullish(),
})
export const catalogResponseSchema = z.object({
  products: z.array(catalogProductSchema), count: z.number().int().nonnegative(),
  limit: z.number().int().positive(), offset: z.number().int().nonnegative(),
})
export type CatalogProduct = z.infer<typeof catalogProductSchema>
export type CatalogImage = z.infer<typeof catalogImageSchema>

export const catalogSearchGatewaySchema = z.object({
  hits: z.array(z.object({
    id: z.string(), product_id: z.string(), variant_id: z.string(),
    product_title: z.string(), variant_title: optionalText, handle: z.string(),
    thumbnail: imageUrl.nullish(), sku: optionalText, ean: optionalText,
    categories: z.array(z.object({ id: z.string(), name: z.string(), handle: z.string() })).optional(),
  })).max(24),
  total: z.number().int().nonnegative(),
  categoryFacets: z.array(z.object({ id: z.string(), name: z.string(), count: z.number().int().nonnegative() })).optional(),
  facetDistribution: z.record(z.string(), z.record(z.string(), z.number().int().nonnegative())).optional(),
})
